import React from "react";

export default ({ strings }) => {
  return (
    <div className="jumbotron">
      <div className="container">
        <h1>{strings.welcome}</h1>
        <p>{strings.help}</p>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Jumbotron.js